/* Extracted from the inline <script> in sections/collection-left-nav.liquid (1 of 3: table render + filter rail) so browsers can cache it; loaded with defer. */
// ---- URL helpers (case-insensitive; supports y/m/mo aliases) ----
function getQP(name) {
  const params = new URLSearchParams(location.search);
  // allow any case: Year / year / YEAR, etc.
  let v = params.get(name);
  if (v == null) {
    // try case-insensitive
    for (const [k, val] of params.entries()) {
      if (k.toLowerCase() === name.toLowerCase()) { v = val; break; }
    }
  }
  return v;
}

// Accept Year/Make/Model (any case) or aliases ?y=?m=?mo=
function readVehicleFromURL() {
  let Year  = getQP('Year')  ?? getQP('y');
  let Make  = getQP('Make')  ?? getQP('m');
  let Model = getQP('Model') ?? getQP('mo');

  if (!Year && !Make && !Model) return null; // no URL params

  // trim & decode
  const dec = s => s == null ? s : decodeURIComponent(String(s)).replace(/\+/g,' ').trim();

  Year  = dec(Year);
  Make  = dec(Make);
  Model = dec(Model);

  // basic normalization
  if (Year && !/^\d{4}$/.test(Year)) Year = null;
  if (Make)  Make  = Make.replace(/\s+/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  if (Model) Model = Model.replace(/\s+/g, ' ').replace(/\b\w/g, c => c.toUpperCase());

  if (Year && Make && Model) return { year: Number(Year), make: Make, model: Model };
  // Partial vehicles are not accepted; a full Y/M/M is required.
  return null;
}

// Optional: validate against your loaded JSON to prevent typos
function validateVehicleAgainstData(sel, data) {
  try {
    if (!sel) return null;
    const ykey = String(sel.year);
    const makes = data?.byYear?.[ykey];
    if (!makes) return null;

    // Case-insensitive match for make
    let okMake = null;
    Object.keys(makes).forEach(m => {
      if (!okMake && m.toLowerCase() === sel.make.toLowerCase()) okMake = m;
    });
    if (!okMake) return null;

    const models = makes[okMake] || [];
    const okModel = models.find(m => m.toLowerCase() === sel.model.toLowerCase());
    if (!okModel) return null;

    return { year: sel.year, make: okMake, model: okModel }; // normalized to canonical casing
  } catch { return null; }
}

// Keep URL in sync with current selection
function updateURLForVehicle(sel, {replace=false} = {}) {
  const params = new URLSearchParams(location.search);
  params.set('Year',  String(sel.year));
  params.set('Make',  sel.make);
  params.set('Model', sel.model);
  const newUrl = location.pathname + '?' + params.toString();
  if (replace) history.replaceState(null, '', newUrl);
  else history.pushState(null, '', newUrl);
}

/* ---------- Row Markup Contract helpers ---------- */
// Files CDN base, rendered by Liquid (via file_url) onto #pc-fitbar's data-files-base
// attribute so this never has to hardcode the shop's file path; falls back to the
// literal only if that attribute is somehow missing.
const PC_FILES_BASE = (function () {
  const fitbarEl = document.getElementById('pc-fitbar');
  const attr = fitbarEl ? fitbarEl.getAttribute('data-files-base') : '';
  return attr || 'https://cdn.shopify.com/s/files/1/0628/1442/1173/files/';
})();

function pcHandleize(s) {
  return String(s || '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

function esc(s) {
  return s == null ? '' : String(s)
    .replace(/&/g,'&amp;').replace(/</g,'&lt;')
    .replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
}

/* ---------- #pc-count-line (toolbar) - vehicle-mode rewrite + SSR restore ---------- */
let lastVehicleLabel = null;

function updateCountLine(n, vehicle) {
  const countEl = document.getElementById('pc-count-line');
  if (!countEl || !vehicle) return;
  const nNum = Number(n);
  const nFmt = isNaN(nNum) ? n : nNum.toLocaleString('en-US');
  // Fit count (CatalogLines/SKUs) and the collection total (products) are
  // different units and can't be meaningfully compared - no "· of N in this
  // category" clause here (SSR default line above keeps that phrasing for
  // the no-vehicle state, where both numbers are the product count).
  countEl.innerHTML = '<span class="pc-mono">' + esc(nFmt) + '</span> parts fit your '
    + esc(vehicle.year) + ' ' + esc(vehicle.make) + ' ' + esc(vehicle.model);
}

// Called from the YMM widget's clearVehicle() (the sole place that clears the
// saved vehicle) to restore the SSR count line + pagination without adding
// a second listener for the same event.
window.pcRestoreSSRCollectionChrome = (function () {
  const countEl = document.getElementById('pc-count-line');
  const defaultHTML = countEl ? countEl.innerHTML : '';
  // Snapshot the SSR tbody once at parse (before any API render can replace it) so a
  // later restore can put back the original rows, not just the count line/pagination/rail
  // chrome around whatever rows happen to be in the table at that moment.
  const ssrTbody = document.querySelector('#view-table tbody[data-ssr]');
  const ssrSnapshot = ssrTbody ? ssrTbody.cloneNode(true) : null;
  return function () {
    if (countEl) countEl.innerHTML = defaultHTML;
    document.querySelectorAll('div.ymm-paginate').forEach(function (div) { div.style.display = ''; });
    lastVehicleLabel = null;

    if (ssrSnapshot) {
      const table = document.querySelector('#view-table table.pc-t');
      if (table) {
        const currentTbody = table.tBodies[0] || table.querySelector('tbody');
        // Always insert a fresh clone - never the snapshot node itself - so repeated
        // clears keep working and the delegated #view-table listeners (which target the
        // table, not the tbody) keep working for the restored rows.
        const freshTbody = ssrSnapshot.cloneNode(true);
        if (currentTbody) table.replaceChild(freshTbody, currentTbody);
        else table.appendChild(freshTbody);
      }
    }

    // Show-more cap: the row set was just rebuilt (vehicle cleared -> SSR
    // rows restored), so reset to the first chunk over the restored rows.
    if (window.pcApplyRowCap) window.pcApplyRowCap({ reset: true });

    if (typeof activeFilters !== 'undefined') {
      for (var k in activeFilters) { if (Object.prototype.hasOwnProperty.call(activeFilters, k)) delete activeFilters[k]; }
    }
    if (typeof lastFilterLines !== 'undefined') lastFilterLines = null;
    var railBox = document.getElementById('sidebar-filters');
    if (railBox) railBox.innerHTML = '';
    var clearBtn = document.getElementById('sidebar-filters-clear');
    if (clearBtn) clearBtn.style.display = 'none';
    if (window.pcSidebarTabs) {
      window.pcSidebarTabs.showFilterEmpty(true);
      window.pcSidebarTabs.updateBadge(0);
    }
  };
})();

/* ---------- Progressive "Show more" row cap (display layer only) ----------
   Caps visible result rows to chunks of PC_CAP_CHUNK at ALL widths (desktop
   table rows and the ≤768px stacked card rows alike) - a 183-row vehicle
   result was a ~94,000px page on mobile. Pure display layer over whatever
   rows the live tbody holds: it never forks the data flow (single
   collection.php call site, SSR snapshot restore, rail facets, sticky sort
   all untouched). Every row-set rebuild funnels through either
   renderCatalogLinesFromAPI() or pcRestoreSSRCollectionChrome(), and both
   call pcApplyRowCap({reset:true}) after swapping the tbody. Rows hidden by
   anything other than this cap (tr.hidden) don't count toward a chunk. The
   "#pc-count-line" copy intentionally keeps the TOTAL result count.
   Focus policy (documented choice): focus STAYS on the Show more button
   after each reveal; only when the final chunk exhausts the list (button
   hides) does focus move to the first newly revealed row's first focusable,
   so keyboard focus is never dropped on <body>. */
const PC_CAP_CHUNK = 40;
let pcCapShown = PC_CAP_CHUNK;

window.pcApplyRowCap = function (opts) {
  if (opts && opts.reset) pcCapShown = PC_CAP_CHUNK;
  const btn = document.getElementById('pc-show-more');
  const tbody = document.querySelector('#view-table table.pc-t tbody');
  if (!tbody) { if (btn) btn.hidden = true; return; }
  const rows = [];
  tbody.querySelectorAll('tr.pc-t__row').forEach(tr => {
    if (tr.hidden) return; // hidden by something other than this cap - doesn't count
    rows.push(tr);
  });
  rows.forEach((tr, idx) => tr.classList.toggle('pc-cap-hidden', idx >= pcCapShown));
  const remaining = Math.max(0, rows.length - pcCapShown);
  if (btn) {
    if (remaining > 0) {
      // CSS text-transform renders this as "SHOW MORE (N REMAINING)".
      btn.textContent = 'Show more (' + remaining.toLocaleString('en-US') + ' remaining)';
      btn.hidden = false;
    } else {
      btn.hidden = true;
    }
  }
};

(function () {
  const btn = document.getElementById('pc-show-more');
  if (btn) {
    btn.addEventListener('click', () => {
      const prevShown = pcCapShown;
      pcCapShown += PC_CAP_CHUNK;
      window.pcApplyRowCap();
      if (btn.hidden) {
        // List exhausted and the button just hid - hand focus to the first
        // newly revealed row's first focusable (see focus policy above).
        const tbody = document.querySelector('#view-table table.pc-t tbody');
        const rows = tbody
          ? Array.prototype.filter.call(tbody.querySelectorAll('tr.pc-t__row'), tr => !tr.hidden)
          : [];
        const target = rows[prevShown];
        const focusable = target && target.querySelector('a[href], button, input, select');
        if (focusable) focusable.focus();
      }
    });
  }
  // Initial SSR cap - the table markup is parsed above this script, and the
  // SSR snapshot (pcRestoreSSRCollectionChrome, above) was already cloned,
  // so the snapshot stays free of pc-cap-hidden classes.
  window.pcApplyRowCap({ reset: true });
})();

function collectFitmentNotes(line) {
  const notes = [];
  const seen = new Set();

  const fitments = Array.isArray(line.Fitment) ? line.Fitment : [];
  for (const f of fitments) {

    // Prefer the provided fitmentNotes, else build from bits
    const raw = (f.fitmentNotes ?? '').toString().trim();
    const note = raw;
    if (!note) continue;

    if (!seen.has(note)) {
      seen.add(note);
      notes.push(note);
    }
  }
  return notes; // array of strings, order preserved
}

/* ---------- Table renderer: replace rows with API CatalogLines ---------- */
function renderCatalogLinesFromAPI(data) {
  const table = document.querySelector('#view-table table.pc-t');
  if (!table) return;

  // ---------- 1) Height lock to prevent collapse/jump ----------
  const card = document.getElementById('view-table');
  const prevHeight = card.offsetHeight;
  card.style.minHeight = prevHeight + 'px';
  card.classList.add('is-loading');

  const oldTbody = table.tBodies[0] || table.querySelector('tbody') || table.appendChild(document.createElement('tbody'));
  const newTbody = document.createElement('tbody');   // build off-DOM
  newTbody.id = 'pc-results-rows'; // keep the id the Show more button's aria-controls targets

  const rows = Array.isArray(data?.CatalogLines) ? data.CatalogLines.slice() : [];
  // Sort: capture the current (post-filter) row set as the "Best fit" baseline for
  // client-side sorting, unless this render call IS the sorted re-render (flagged below).
  if (!data.__pcSorted) {
    window.pcVehicleBaseRows = rows.slice();
    // Keep an active sort sticky across filter/vehicle re-renders that funnel back through
    // this renderer with fresh (unsorted) rows - e.g. a sidebar filter checkbox toggling.
    if (window.pcCurrentSort && window.pcCurrentSort !== 'best-fit' && typeof window.pcSortRows === 'function') {
      rows.splice(0, rows.length, ...window.pcSortRows(rows, window.pcCurrentSort));
    }
  }
  // --- Pin product(s) by variantId from URL to the top ---
	const pinnedIds = getPinnedIdsFromURL();
	if (pinnedIds.length && rows.length) {
	  // Stable decorate-sort-undecorate so we don't disturb relative order
	  const pinnedSet = new Set(pinnedIds.map(String));
	  const decorated = rows.map((line, i) => ({
		line,
		i,
		pin: pinnedSet.has(String(line?.Availability?.variantId)) ? 0 : 1
	  }));
	  decorated.sort((a, b) => (a.pin - b.pin) || (a.i - b.i));
	  for (let k = 0; k < rows.length; k++) rows[k] = decorated[k].line;
	}



  // Filter / sort / in-stock re-renders call this with only { CatalogLines }, so fall
  // back to the vehicle from the last collection.php response. Without this the rows'
  // properties[Fitment] lost the Year Make Model and carts showed only the qualifiers.
  const year	  = data.year  || lastVehicleLabel?.year  || '';
  const make	  = data.make  || lastVehicleLabel?.make  || '';
  const model	  = data.model || lastVehicleLabel?.model || '';
  if (year && make && model) lastVehicleLabel = { year, make, model };

  // Empty-state row (build into newTbody, not the live DOM)
  if (rows.length === 0) {
    const tr = document.createElement('tr');
    const td = document.createElement('td');
    td.colSpan = 7;
    td.className = 'muted';
    td.textContent = 'No matching parts for this vehicle in this collection.';
    tr.appendChild(td);
    newTbody.appendChild(tr);
  } else {
    const frag = document.createDocumentFragment();

    for (const line of rows) {
      const brand      = line.Brand || '';
      const sku        = line.sku ? line.sku.slice(5) : (line?.Availability?.handle || '');
      const pos        = line.Position || '';
      const lineName   = line.Subgroup || '';
      const title      = line.Subcategory || '';
      const priceRaw   = line?.Availability?.price;
      const inventory  = line?.Availability?.inventoryQuantity;
      const handle     = line?.Availability?.handle || '';
      const variantId  = line?.Availability?.variantId || '';
      const images     = Array.isArray(line.Images) ? line.Images : [];
      const thumb      = line.Thumb || images[0]?.src || '';
      const productUrl = handle ? '/products/' + handle : '#';

      // Fitment notes: same single-note-slot vocabulary as the SSR row's .pc-t__note
      // (fitment.notes joined with mfr_label via " • "). Here fitmentNotesArray
      // stands in for fitment.notes and line.Notes stands in for mfr_label.
      const fitmentNotesArray = collectFitmentNotes(line);
      const mfrNote = line.Notes || '';
      const notePieces = [];
      if (fitmentNotesArray.length) notePieces.push(fitmentNotesArray.join('; '));
      if (mfrNote) notePieces.push(mfrNote);
      const noteText = notePieces.join(' • ');

      // properties[Fitment] hidden input value - vehicle + joined fitment notes / mfr
      // note, then "Position: …" / "Note: …" lines in the same wording fits.php's
      // verify message uses. The guarantee flow (pc-guarantee-collection.js) replaces
      // this with the verify message when it verifies; this value is what reaches
      // the cart when it doesn't (its 4 s bail-out, a failed lookup), so it has to
      // carry the position and note too rather than a bare "All".
      const propBlankish = v => !v || ['U/K', 'N/A', 'N/R', '-'].includes(String(v).trim().toUpperCase());
      const fitNote = (line.Note ?? '').toString().trim();
      const propExtraLines = [];
      if (!propBlankish(pos)) propExtraLines.push('Position: ' + esc(pos));
      if (!propBlankish(fitNote)) propExtraLines.push('Note: ' + esc(fitNote));
      const fitmentNotesJoinedForProp = fitmentNotesArray.map(esc).join('<br />') || (propExtraLines.length ? '' : 'All');
      const propNoteHtml = mfrNote
        ? `${fitmentNotesJoinedForProp}${fitmentNotesJoinedForProp ? ' • ' : ''}<span class="muted">${esc(mfrNote)}</span>`
        : fitmentNotesJoinedForProp;
      const vehicleLabel = [year, make, model].filter(Boolean).map(esc).join(' ');
      const fitmentPropertyValue = [vehicleLabel, propNoteHtml].concat(propExtraLines).filter(Boolean).join('<br />');

      const invNum = Number(inventory);
      let stockClass = 'pc-t__stock--out';
      let stockLabel = 'Out of stock';
      if (invNum > 5) {
        stockClass = 'pc-t__stock--in';
        stockLabel = 'In stock';
      } else if (invNum > 0) {
        stockClass = 'pc-t__stock--low';
        stockLabel = 'Only ' + invNum + ' left';
      }

      // ?width=192 resizes through the image CDN (96px slot at 2x); the raw
      // file was the full-size upload, 20-200 KB per logo.
      const brandLogoUrl = brand ? PC_FILES_BASE + pcHandleize(brand) + '.png?width=192' : '';
      const priceNum = Number(priceRaw);
      const priceDisplay = (priceRaw != null && priceRaw !== '' && isFinite(priceNum)) ? '$' + priceNum.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '';

      const isPinned = pinnedIds.includes(String(variantId));

      let buyHtml = '';
      if (invNum > 0) {
        buyHtml = `
          <form method="post" action="${esc(window.routes.cart_add_url)}" class="pc-t__buy">
            <input type="hidden" name="id" value="${esc(variantId)}">
            <input type="hidden" name="properties[Fitment]" value="${fitmentPropertyValue}">
            <div class="pc-t__qty">
              <button type="button" class="pc-t__qty-dec" aria-label="Decrease quantity">&minus;</button>
              <input class="pc-t__qty-n" type="text" inputmode="numeric" name="quantity" value="1" aria-label="Quantity">
              <button type="button" class="pc-t__qty-inc" aria-label="Increase quantity">+</button>
            </div>
            <button type="submit" class="pc-t__add">Add</button>
          </form>`;
      }

      const tr = document.createElement('tr');
      tr.className = 'pc-t__row';
      if (isPinned) tr.classList.add('pinned');
      tr.innerHTML = `
        <td class="pc-t__img"><a href="${esc(productUrl)}">${thumb ? `<img src="${esc(thumb)}" alt="${esc(title)}" loading="lazy" width="64" height="64" onerror="window.pcImgFallback&&window.pcImgFallback(this)">` : `<span class="pc-t__noimg" aria-hidden="true">${window.PC_NOIMG_SVG}</span>`}</a></td>
        <td class="pc-t__part">
          <a class="pc-t__title" href="${esc(productUrl)}">${esc(title)}</a>
          ${lineName ? `<div class="pc-t__line">${esc(lineName)}</div>` : ''}
          ${noteText ? `<div class="pc-t__note" title="${esc(noteText)}">${esc(noteText)}</div>` : ''}
        </td>
        <td class="pc-t__brand">
          ${brand
            ? `<a class="pc-t__brandlink" href="/collections/${esc(pcHandleize(brand))}" title="All ${esc(brand)} parts"><img class="pc-t__brandlogo" src="${esc(brandLogoUrl)}" alt="${esc(brand)}" width="96" height="22" onload="this.nextElementSibling.style.display='none'" onerror="this.style.display='none';this.nextElementSibling.classList.add('pc-t__brandword--solo')">
          <div class="pc-t__brandword">${esc(brand)}</div></a>`
            : `<div class="pc-t__brandword pc-t__brandword--solo"></div>`}
        </td>
        <td class="pc-t__sku"><a class="pc-t__sku-link" href="${esc(productUrl)}">${esc(sku)}</a></td>
        <td class="pc-t__pos">${pos ? esc(pos) : '&mdash;'}</td>
        <td class="pc-t__price">${esc(priceDisplay)}</td>
        <td class="pc-t__avail">
          <div class="pc-t__stock ${stockClass}"><span class="pc-t__dot"></span>${stockLabel}</div>
          ${buyHtml}
        </td>
      `;
      frag.appendChild(tr);
    }

    newTbody.appendChild(frag);

  }

  // ---------- 2) One-shot swap + gentle fade ----------
  // Add fade classes before we attach so the browser can animate in.
  newTbody.classList.add('fade-enter');
  table.replaceChild(newTbody, oldTbody);        // atomic swap

  // Show-more cap: every rebuild funnels through this renderer - vehicle
  // apply/refine (sendVehicleToAPI), rail facet filtering (applyFitmentFilters
  // passes only the rows that survived the filters, so hidden-by-filter rows
  // never reach the DOM and can't count toward a chunk), and sort re-orders
  // (__pcSorted re-render). Reset to the first chunk over the new row set.
  if (window.pcApplyRowCap) window.pcApplyRowCap({ reset: true });
  // Force style calc, then start transition
  newTbody.getBoundingClientRect();
  newTbody.classList.add('fade-enter-active');

  // Hide paginate controls when filtered
  document.querySelectorAll('div.ymm-paginate').forEach(div => { div.style.display = 'none'; });

  // ---------- Count line ----------
  updateCountLine(rows.length, lastVehicleLabel);

  // ---------- 3) Release height lock after paint ----------
  // Give the fade a moment; then remove helpers.
  window.requestAnimationFrame(() => {
    setTimeout(() => {
      card.classList.remove('is-loading');
      // Allow the card to shrink/grow to the new content smoothly
      card.style.minHeight = '';
      // Clean up the helper class to keep DOM tidy
      newTbody.classList.remove('fade-enter','fade-enter-active');
    }, 140);
  });
}



/* ---------- Condensed, labeled single-bubble filters ---------- */
// Vehicle-qualifier keys (the QUAL_KEYS family down in the YMM
// widget below - Submodel/BodyType/DriveType/EngineVIN/FuelType/etc.) no
// longer produce rail facets; the rail now covers Brand, Part Type, Product
// line (#12's new Subgroup facet), and Position only. Qualifier narrowing
// happens up in the vehicle picker itself (renderVehicleRefinements).
// Key order here is the render order in the rail: renderFilterPills walks
// Object.keys(FITMENT_LABELS). Part Type leads because it is the coarsest cut
// a shopper makes, then Position narrows within it.
const FITMENT_LABELS = {
  'Subcategory': 'Part Type',
  'Position': 'Position',
  'Brand': 'Brand',
  'Subgroup': 'Product line'
};

const TOP_LEVEL_ONLY = new Set(['Brand', 'Subcategory', 'Subgroup']);
const eqCI = (a, b) =>
  String(a ?? '').trim().toLowerCase() === String(b ?? '').trim().toLowerCase();

const activeFilters = {}; // { key: value }
let lastFilterLines = null;

// "In Stock Only" - standing rail toggle, ON by default
let inStockOnly = true;

// Groups whose "Show N more" was clicked - survives the re-render that every
// filter change triggers, so an expanded list stays expanded.
const expandedGroups = new Set();
const lineInStock = line => Number(line?.Availability?.inventoryQuantity) > 0;

document.getElementById('sidebar-filters-clear')?.addEventListener('click', () => {
  for (const k of Object.keys(activeFilters)) delete activeFilters[k];
  inStockOnly = false;
  if (lastFilterLines) {
    applyFitmentFilters(lastFilterLines, activeFilters);
    renderFilterPills(lastFilterLines);
  }
});

function normalizeVal(v) {
  if (v == null) return v;
  const s = String(v).trim();
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
}

/* Position display: capitalize every word ("Front Left", "Front And Rear") */
function titleCaseVal(v) {
  if (v == null) return v;
  return String(v).trim().toLowerCase().replace(/\b[a-z]/g, c => c.toUpperCase());
}

function extractField(obj, key) {
  if (!obj) return null;
  if (key.includes('.')) {
    const [root, child] = key.split('.');
    const parent = obj[root];
    return parent && parent[child] != null ? parent[child] : null;
  }
  return obj[key] ?? null;
}

function collectLineValues(line, key) {
  const out = new Set();

  if (TOP_LEVEL_ONLY.has(key)) {
    const v = line[key];
    if (v != null && String(v).trim() !== '') out.add(v);
    return out;
  }

  // existing per-fitment harvest - the only non-TOP_LEVEL_ONLY
  // rail key left is 'Position' (the QUAL_KEYS-family keys this list used to
  // also normalize are no longer rail facets - see FITMENT_LABELS above).
  const fits = Array.isArray(line.Fitment) ? line.Fitment : [];
  for (const f of fits) {
    let v = extractField(f, key);
    if (key === 'Position') v = titleCaseVal(v);
    if (v != null && String(v).trim() !== '') out.add(v);
  }

  // fallback to top-level if present
  let top = extractField(line, key);
  if (key === 'Position') top = titleCaseVal(top);
  if (top != null && String(top).trim() !== '') out.add(top);

  return out;
}


const RAIL_SHOW_LIMIT = 8;

/* Logical display order for the Position group (unknowns append A-Z) */
const POSITION_ORDER = ['Front', 'Front Left', 'Front Right',
                        'Rear', 'Rear Left', 'Rear Right', 'Front And Rear'];
function sortPositions(vals) {
  const rank = v => {
    const i = POSITION_ORDER.findIndex(p => eqCI(p, v));
    return i === -1 ? POSITION_ORDER.length : i;
  };
  return vals.sort((a, b) => (rank(a) - rank(b)) || String(a).localeCompare(String(b)));
}

function updateSidebarFilterChrome() {
  let activeCount = 0;
  for (const k of Object.keys(activeFilters)) activeCount += activeFilters[k].size;
  if (window.pcSidebarTabs) window.pcSidebarTabs.updateBadge(activeCount);
  const clearBtn = document.getElementById('sidebar-filters-clear');
  if (clearBtn) clearBtn.style.display = activeCount > 0 ? '' : 'none';
}

function renderFilterPills(allLines) {
  const box = document.getElementById('sidebar-filters');
  if (!box) return;

  lastFilterLines = allLines;
  if (window.pcSidebarTabs) window.pcSidebarTabs.showFilterEmpty(false);

  const keys = Object.keys(FITMENT_LABELS);

  // gather distinct values per key from ALL fitments in ALL lines
  const valuesByKey = {};
  for (const key of keys) valuesByKey[key] = new Set();

  for (const line of allLines) {
    for (const key of keys) {
      const vals = collectLineValues(line, key);
      vals.forEach(v => valuesByKey[key].add(v));
    }
  }

  const activeKeys = keys.filter(k => valuesByKey[k].size > 0);

  box.innerHTML = '';

  // Shared row builder for both the checkbox-list groups and the Position
  // chip group: a chip IS a checkbox (native input, hidden and restyled via
  // CSS :has()), so there is exactly one change-handler code path for every
  // filter value regardless of how it's presented.
  function buildFilterRow(key, val, opts) {
    const lbl = document.createElement('label');
    lbl.className = opts.chip ? 'pc-rail__chip' : 'pc-rail__check';

    const cb = document.createElement('input');
    cb.type = 'checkbox';
    cb.value = val;
    cb.checked = (activeFilters[key]?.has(val) ?? false);

    const span = document.createElement('span');
    span.className = opts.chip ? 'pc-rail__chip-text' : 'pc-rail__check-text';
    span.textContent = val;

    lbl.appendChild(cb);
    lbl.appendChild(span);

    if (!opts.chip) {
      const count = document.createElement('span');
      count.className = 'pc-rail__count pc-mono';
      count.textContent = (typeof opts.count === 'number') ? opts.count.toLocaleString('en-US') : (opts.count ?? '');
      lbl.appendChild(count);
    }

    cb.addEventListener('change', () => {
      if (!activeFilters[key]) activeFilters[key] = new Set();
      if (cb.checked) {
        activeFilters[key].add(val);
      } else {
        activeFilters[key].delete(val);
        if (activeFilters[key].size === 0) delete activeFilters[key];
      }
      applyFitmentFilters(allLines, activeFilters);
      updateSidebarFilterChrome();
      renderFilterPills(allLines);   // refresh counts / disabled options
    });

    return lbl;
  }

  // "In Stock Only" toggle - pinned above every facet group. Wrapped in a
  // .pc-rail__list so it inherits the same font as the facet rows below it,
  // and its count respects the active facet selections.
  {
    const stockGroup = document.createElement('div');
    stockGroup.className = 'pc-rail__group';
    const stockList = document.createElement('div');
    stockList.className = 'pc-rail__list';
    const stockLbl = document.createElement('label');
    stockLbl.className = 'pc-rail__check';
    const stockCb = document.createElement('input');
    stockCb.type = 'checkbox';
    stockCb.checked = inStockOnly;
    const stockTxt = document.createElement('span');
    stockTxt.className = 'pc-rail__check-text';
    stockTxt.textContent = 'In Stock Only';
    const stockCount = document.createElement('span');
    stockCount.className = 'pc-rail__count pc-mono';
    stockCount.textContent = allLines
      .filter(l => lineMatchesFilters(l, activeFilters, null))
      .filter(lineInStock).length.toLocaleString('en-US');
    stockLbl.appendChild(stockCb);
    stockLbl.appendChild(stockTxt);
    stockLbl.appendChild(stockCount);
    stockCb.addEventListener('change', () => {
      inStockOnly = stockCb.checked;
      applyFitmentFilters(allLines, activeFilters);
      updateSidebarFilterChrome();
      renderFilterPills(allLines);   // refresh counts / disabled options
    });
    stockList.appendChild(stockLbl);
    stockGroup.appendChild(stockList);
    box.appendChild(stockGroup);
  }

  for (const key of activeKeys) {
    const group = document.createElement('div');
    group.className = 'pc-rail__group';

    const label = document.createElement('div');
    label.className = 'pc-rail__label';
    label.textContent = FITMENT_LABELS[key];
    group.appendChild(label);

    const isPosition = key === 'Position';
    let vals = Array.from(valuesByKey[key]).sort((a,b)=>String(a).localeCompare(String(b)));
    if (isPosition) vals = sortPositions(vals);

    // Faceted counts: count against lines passing the stock toggle and every
    // OTHER group's selections, so each number answers "what would checking
    // this show?" - zero means the option is dead under the current criteria.
    const contextLines = (inStockOnly ? allLines.filter(lineInStock) : allLines)
      .filter(l => lineMatchesFilters(l, activeFilters, key));
    const counts = new Map();
    for (const v of vals) counts.set(v, 0);
    for (const line of contextLines) {
      collectLineValues(line, key).forEach(v => {
        if (counts.has(v)) counts.set(v, counts.get(v) + 1);
      });
    }

    // Live options first (in their normal order), dead ones sink to the
    // bottom, grayed and unclickable. A checked option is never dead.
    const isOn = v => activeFilters[key]?.has(v) ?? false;
    const ordered = vals.filter(v => counts.get(v) > 0 || isOn(v))
              .concat(vals.filter(v => !(counts.get(v) > 0 || isOn(v))));

    const wrap = document.createElement('div');
    wrap.className = 'pc-rail__list';

    // Overflow: hide rows past the limit UNLESS the group was expanded via
    // "Show more" (state survives re-renders) or the row is checked - a
    // selected option must never disappear back under the fold.
    const expanded = expandedGroups.has(key);
    let hiddenCount = 0;
    ordered.forEach((val, idx) => {
      const row = buildFilterRow(key, val, { chip: false, count: counts.get(val) });
      if (counts.get(val) === 0 && !isOn(val)) {
        row.classList.add('pc-rail__check--off');
        row.querySelector('input').disabled = true;
      }
      if (!expanded && idx >= RAIL_SHOW_LIMIT && !isOn(val)) {
        row.hidden = true;
        hiddenCount++;
      }
      wrap.appendChild(row);
    });

    group.appendChild(wrap);

    if (hiddenCount > 0) {
      const more = document.createElement('button');
      more.type = 'button';
      more.className = 'pc-rail__more';
      more.textContent = 'Show ' + hiddenCount + ' more';
      more.addEventListener('click', () => {
        expandedGroups.add(key);
        wrap.querySelectorAll('.pc-rail__check[hidden]').forEach(el => { el.hidden = false; });
        more.remove();
      });
      group.appendChild(more);
    }

    box.appendChild(group);
  }

  updateSidebarFilterChrome();
}

function getPinnedIdsFromURL() {
  // allow productID, productId, variantId; comma-separated supported
  const raw =
    getQP('productID') ??
    getQP('productId') ??
    getQP('variantId');
  if (!raw) return [];
  return String(raw)
    .split(',')
    .map(s => s.trim())
    .filter(Boolean);
}


/* AND across keys; OR within each key's Set. excludeKey lets the facet
   renderer count a group against every OTHER group's selections. */
function lineMatchesFilters(line, filters, excludeKey) {
  for (const [key, allowed] of Object.entries(filters)) {
    if (key === excludeKey) continue;
    if (TOP_LEVEL_ONLY.has(key)) {
      const v = line[key];
      if (![...allowed].some(r => eqCI(v, r))) return false;
    }
  }

  const fits = Array.isArray(line.Fitment) && line.Fitment.length ? line.Fitment : [ {} ];

  return fits.some(fit => {
    return Object.entries(filters).every(([key, allowed]) => {
      if (key === excludeKey || TOP_LEVEL_ONLY.has(key)) return true;

      let v = extractField(fit, key);
      if (v == null || v === '') v = extractField(line, key);

      if (key === 'Position') v = titleCaseVal(v);

      if (v == null || v === '') return true;

      return [...allowed].some(r => eqCI(v, r));
    });
  });
}

function applyFitmentFilters(allLines, filters) {
  const base = inStockOnly ? allLines.filter(lineInStock) : allLines;
  const hasFilters = filters && Object.keys(filters).length > 0;
  if (!hasFilters) { renderCatalogLinesFromAPI({ CatalogLines: base }); return; }

  const filtered = base.filter(line => lineMatchesFilters(line, filters, null));

  renderCatalogLinesFromAPI({ CatalogLines: filtered });
}
